import script from "./Submission.vue?vue&type=script&setup=true&lang=js"
export * from "./Submission.vue?vue&type=script&setup=true&lang=js"

import "./Submission.vue?vue&type=style&index=0&id=5741c6cd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5741c6cd"]])

export default __exports__